<template>
  <modal transition="pop-out" name="image-upload" :width="900" :height="520">
    <div id="image-upload-form" class="image-upload-form p-4">
      <el-alert
        title="error alert"
        type="error"
        v-if="errorText.length > 0"
        effect="dark">
        <h5>{{errorText}}</h5>
      </el-alert>
      <el-alert
        title="success alert"
        v-if="successText.length > 0"
        type="success"
        effect="dark">
        <h5 >{{successText}}</h5>
      </el-alert>
      <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
        <h3>Drop files to upload</h3>
      </div>
      <div class="upload">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Thumb</th>
              <th>Name</th>
              <th>Size</th>
              <th>Speed</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!files.length">
              <td colspan="7">
                <div class="text-center p-5">
                  <h4>Drop file anywhere to upload<br/>or</h4>
                  <label :for="name" class="btn btn-lg btn-primary">Select File</label>
                </div>
              </td>
            </tr>
            <tr v-for="(file, index) in files" :key="file.id">
              <td>
                <img v-if="file.thumb" :src="file.thumb" width="40" height="auto" />
                <span v-else>No Image</span>
              </td>
              <td>
                <div class="filename">
                  {{file.name}}
                </div>
                <div class="progress" v-if="file.active || file.progress !== '0.00'">
                  <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                </div>
              </td>
              <td>{{file.size | formatSize}}</td>
              <td>{{file.speed | formatSize}}</td>
              <td v-if="file.error">{{file.error}}</td>
              <td v-else-if="file.success">success</td>
              <td v-else-if="file.active">active</td>
              <td v-else></td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-secondary btn-sm dropdown-toggle" type="button">
                    Action
                  </button>
                  <div class="dropdown-menu dropdown-menu-left">
                    <a class="dropdown-item" href="#" v-if="file.error && file.error !== 'compressing' && $refs.upload.features.html5" @click.prevent="$refs.upload.update(file, {active: true, error: '', progress: '0.00'})">Retry upload</a>
                    <a :class="{'dropdown-item': true, disabled: file.success || file.error === 'compressing'}" href="#" v-else @click.prevent="file.success || file.error === 'compressing' ? false : $refs.upload.update(file, {active: true})">Upload</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click.prevent="$refs.upload.remove(file)">Remove</a>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="example-foorer">
          <div class="btn-group">
            <FileUpload
              class="btn btn-primary dropdown-toggle"
              :post-action="url"
              :extensions="extensions"
              :accept="accept"
              :directory="directory"
              :size="size || 0"
              :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
              :headers="headers"
              :drop="drop"
              :data="data"
              :add-index="addIndex"
              v-model="files"
              @input-filter="inputFilter"
              @input-file="inputFile"
              @input="validateFiles"
              ref="upload">
              <i class="fa fa-plus"></i>
              Select
            </FileUpload>
            <div class="dropdown-menu">
              <label class="dropdown-item" :for="name">Add files</label>
            </div>
          </div>
          <button type="button" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
            Start Upload
          </button>
          <button type="button" class="btn btn-danger"  v-else @click.prevent="$refs.upload.active = false">
            <i class="fa fa-stop" aria-hidden="true"></i>
            Stop Upload
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ImageUpload',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      files: [],
      accept: 'image/png,image/gif,image/jpeg,image/webp',
      extensions: 'gif,jpg,jpeg,png,webp',
      size: 1024 * 300,
      multiple: true,
      directory: false,
      drop: true,
      data: {},
      addIndex: false,
      thread: 3,
      name: 'file',
      // postAction: this.url,
      headers: {
        // JWT Token
      },
      uploadAuto: false,
      isOption: false,
      errorText: '',
      successText: '',
    };
  },
  filters: {
    formatSize(size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024 / 1024 / 1024).toFixed(2)} TB`;
      } if (size > 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`;
      } if (size > 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(2)} MB`;
      } if (size > 1024) {
        return `${(size / 1024).toFixed(2)} KB`;
      }
      return `${size.toString()} B`;
    },
  },
  methods: {
    validateFiles(value) {
      value.forEach((file) => {
        if (file.size > this.size) {
          file.error = 'File size too large';
          this.$message.error('Oops, this file is too large. Make sure file is less than 300kb');
        }
      });
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },
    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile) {
        console.log(newFile.response);
        if (newFile.response && newFile.response.data && newFile.response.data.error) {
          this.errorText = 'Image Upload Failed try again';
        }

        if (newFile.response && newFile.response.status === 'success') {
          this.successText = `${newFile.name} was uploaded successfully`;
        }
      }
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
};
</script>

<style lang="scss">
  @import "node_modules/bootstrap/scss/bootstrap";
</style>

<style lang="scss">
  #image-upload-form {
    height: 400px;
  }
  #image-upload-form .btn-group .dropdown-menu {
    display: block;
    visibility: hidden;
    transition: all .2s;
  }
  .upload {
    height: 100%;
  }
  .table-responsive {
    height: 100%;
  }
  #image-upload-form .btn-group:hover > .dropdown-menu {
    visibility: visible;
  }
  #image-upload-form label.dropdown-item {
    margin-bottom: 0;
  }
  #image-upload-form .btn-group .dropdown-toggle {
    margin-right: .6rem
  }
  #image-upload-form .filename {
    margin-bottom: .3rem
  }
  #image-upload-form .btn-is-option {
    margin-top: 0.25rem;
  }
  #image-upload-form .example-foorer {
    padding: .5rem 0;
    border-top: 1px solid #e9ecef;
    border-bottom: 1px solid #e9ecef;
  }
  #image-upload-form .edit-image img {
    max-width: 100%;
  }
  #image-upload-form .edit-image-tool {
    margin-top: .6rem;
  }
  #image-upload-form .edit-image-tool .btn-group{
    margin-right: .6rem;
  }
  #image-upload-form .footer-status {
    padding-top: .4rem;
  }
  #image-upload-form .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }
  #image-upload-form .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
</style>
